import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AppThemeProvider } from "./context/theme";
import { AuthProvider }     from "./context/auth";
import AppRoutes            from "./routes";

// -- Import global font styles
import "./styles/fonts/index.css";

function App() {
  return (
    // AppThemeProvider must wrap everything to apply MUI theme globally
    <AppThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </LocalizationProvider>
    </AppThemeProvider>
  );
}

export default App;